export const isGema = function (tenantName: string): boolean {
  return tenantName.toLowerCase().trim() === "gema";
  //   return tenantName.toLowerCase().trim() === "demo";
};

export const isGemaProd = function (tenantId: string): boolean {
  return tenantId === "192784e2-01d7-4676-ab96-75f44fca2b28";
};
